import _extends from 'babel-runtime/helpers/extends';
import _Object$keys from 'babel-runtime/core-js/object/keys';

import { filedGetFieldAPI } from '@/api/crm/common';
import { crmReceivablesSaveAPI } from '@/api/crm/receivables';

import XrCreate from '@/components/XrCreate';
import CreateSections from '@/components/CreateSections';
import WkFormItems from '@/components/NewCom/WkForm/WkFormItems';
import { XhReceivablesPlan, CrmRelativeCell } from '@/components/CreateCom';
import CreateExamineInfo from '@/components/Examine/CreateExamineInfo';

import CustomFieldsMixin from '@/mixins/CustomFields';
import { debounce } from 'throttle-debounce';
import { objDeepCopy } from '@/utils';
// import { isEmpty } from '@/utils/types'

export default {
  // 新建编辑
  name: 'ReceivablesCreate',

  components: {
    XrCreate: XrCreate,
    CreateSections: CreateSections,
    CrmRelativeCell: CrmRelativeCell,
    XhReceivablesPlan: XhReceivablesPlan,
    CreateExamineInfo: CreateExamineInfo,
    WkFormItems: WkFormItems
  },

  mixins: [CustomFieldsMixin],

  props: {
    action: {
      type: Object,
      default: function _default() {
        return {
          type: 'save',
          id: '',
          data: {}
        };
      }
    }
  },

  data: function data() {
    return {
      loading: false,
      baseFields: [],
      fieldList: [],
      fieldForm: {},
      fieldRules: {},

      // 审批信息
      examineInfo: {}
    };
  },


  computed: {
    title: function title() {
      return this.action.type === 'update' ? '编辑回款' : '新建回款';
    },
    editId: function editId() {
      return this.action.type == 'update' ? this.action.id : '';
    },


    // 合同 回款 下展示审批人信息
    isOpenExamine: function isOpenExamine() {
      if (this.examineInfo) {
        // 初始状态是空对象默认展示，请求之后，根据status判断
        return _Object$keys(this.examineInfo).length > 0 ? this.examineInfo.examineStatus : true;
      }
      return false;
    },


    // 确认名称
    sureBtnTitle: function sureBtnTitle() {
      if (this.isOpenExamine) {
        return '提交审核';
      }
      return '保存';
    }
  },

  watch: {},

  created: function created() {
    this.debouncedSaveField = debounce(300, this.saveClick);

    this.getField();
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    /**
     * 获取数据
     */
    getField: function getField() {
      var _this = this;

      this.loading = true;
      var params = {
        // label: crmTypeModel.receivables
        types: 'crm_receivables',
        module: 'crm',
        controller: 'receivables',
        action: this.action.type,
        format: 2
      };

      if (this.action.type == 'update') {
        params.action_id = this.action.id;
      }

      filedGetFieldAPI(params).then(function (res) {
        var list = res.data || [];
        var assistIds = _this.getFormAssistIds(list);

        var baseFields = [];
        var fieldList = [];
        var fieldRules = {};
        var fieldForm = {};
        list.forEach(function (children) {
          var fields = [];
          children.forEach(function (item) {
            var temp = _this.getFormItemDefaultProperty(item);
            temp.show = !assistIds.includes(item.formAssistId);

            var canEdit = _this.getItemIsCanEdit(item, _this.action.type);
            // 是否能编辑权限
            if (canEdit) {
              // 自动生成编号
              if (item.autoGeneNumber == 1) {
                temp.placeholder = '根据编号规则自动生成，支持手动输入';
                var copyItem = objDeepCopy(item);
                copyItem.isNull = 0;
                fieldRules[temp.field] = _this.getRules(copyItem);
              } else {
                fieldRules[temp.field] = _this.getRules(item);
              }
            }

            // 是否可编辑
            temp.disabled = !canEdit;

            // 禁止某些业务组件选择
            if (temp.form_type == 'receivables_plan' || temp.form_type == 'contract' || temp.form_type == 'customer') {
              if (_this.action.type == 'relative') {
                var relativeDisInfos = {
                  contacts: { customer: true },
                  customer: { customer: true },
                  business: { customer: true },
                  contract: { customer: true, contract: true }

                  // 在哪个类型下添加
                };var relativeTypeDisInfos = relativeDisInfos[_this.action.crmType];
                if (relativeTypeDisInfos) {
                  // 包含的字段值
                  temp.disabled = relativeTypeDisInfos[item.form_type] || false;
                }
              } else if (_this.action.type != 'update') {
                temp.disabled = item.form_type === 'contract' || item.form_type === 'receivables_plan';
              }
            }

            // 处理关联
            if (_this.action.type == 'relative' || _this.action.type == 'update') {
              // 回款计划 需要合同信息
              if (item.form_type === 'receivables_plan') {
                var contractItem = _this.getItemRelatveInfo(list, 'contract');
                if (contractItem) {
                  contractItem['moduleType'] = 'contract';
                  temp['relation'] = contractItem;
                }
                // 合同 需要客户信息
              } else if (item.form_type == 'contract') {
                var customerItem = _this.getItemRelatveInfo(list, 'customer');
                if (customerItem) {
                  customerItem['moduleType'] = 'customer';
                  customerItem['params'] = { check_status: 2 };
                  temp['relation'] = customerItem;
                }
              }
            }

            // 特殊字段允许多选
            _this.getItemRadio(item, temp);

            // 获取默认值
            if (temp.show) {
              fieldForm[temp.field] = _this.getItemValue(item, _this.action.data, _this.action.type);
            }
            fields.push(temp);
            baseFields.push(item);
          });
          fieldList.push(fields);
        });

        _this.baseFields = baseFields;
        _this.fieldList = fieldList;
        _this.fieldForm = fieldForm;
        _this.fieldRules = fieldRules;

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },


    /**
     * 保存
     */
    saveClick: function saveClick() {
      var _this2 = this;

      var isDraft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.loading = true;
      var crmForm = this.$refs.crmForm;
      crmForm.validate(function (valid) {
        if (valid) {
          if (_this2.isOpenExamine) {
            /** 验证审批数据 */
            if (isDraft) {
              // 不验证数据 验证审批人
              _this2.$refs.examineInfo.validateField(function (result) {
                if (result) {
                  var params = _this2.getSubmiteParams(_this2.baseFields, _this2.fieldForm);
                  if (_this2.examineInfo.config === 0 && _this2.examineInfo.hasOwnProperty('value') && _this2.examineInfo.value.length) {
                    params['check_user_id'] = _this2.examineInfo.value[0].id;
                  }
                  params['examineStatus'] = _this2.examineInfo.examineStatus;
                  params.is_draft = 1;
                  _this2.submiteParams(params);
                } else {
                  _this2.loading = false;
                }
              });
            } else {
              _this2.$refs.examineInfo.validateField(function (result) {
                if (result) {
                  var params = _this2.getSubmiteParams(_this2.baseFields, _this2.fieldForm);

                  params['examineStatus'] = _this2.examineInfo.examineStatus;
                  if (_this2.examineInfo.config === 0) {
                    params['check_user_id'] = _this2.examineInfo.value[0].id;
                  }
                  _this2.submiteParams(params);
                } else {
                  _this2.loading = false;
                }
              });
            }
          } else {
            var params = _this2.getSubmiteParams(_this2.baseFields, _this2.fieldForm);
            if (isDraft) {
              params.is_draft = 1;
            }
            _this2.submiteParams(params);
          }
        } else {
          _this2.loading = false;
          // 提示第一个error
          _this2.getFormErrorMessage(crmForm);
          return false;
        }
      });
    },


    /**
     * 提交上传
     */
    submiteParams: function submiteParams(params) {
      var _this3 = this;

      if (this.action.type == 'update') {
        params.id = this.action.id;
        params.batchId = this.action.batchId;
      }

      // 相关添加时候的多余提交信息
      if (this.action.relativeData && _Object$keys(this.action.relativeData).length) {
        params = _extends({}, params, this.action.relativeData);
      }
      crmReceivablesSaveAPI(params).then(function (res) {
        _this3.loading = false;

        _this3.$message.success(_this3.action.type == 'update' ? '编辑成功' : '添加成功');

        _this3.close();

        // 保存成功
        _this3.$emit('save-success', {
          type: 'receivables'
        });
      }).catch(function () {
        _this3.loading = false;
      });
    },


    /**
     * 验证唯一
     */
    UniquePromise: function UniquePromise(_ref) {
      var field = _ref.field,
          value = _ref.value;

      return this.getUniquePromise(field, value, this.action);
    },


    /**
     * change
     */
    formChange: function formChange(field, index, value, valueList) {
      // 审批流逻辑
      // this.debouncedGetWkFlowList(field.field, this.fieldForm)

      if (['select', 'checkbox'].includes(field.formType) && field.remark === 'options_type' && field.optionsData) {
        var _getFormContentByOpti = this.getFormContentByOptionsChange(this.fieldList, this.fieldForm),
            fieldForm = _getFormContentByOpti.fieldForm,
            fieldRules = _getFormContentByOpti.fieldRules;

        this.fieldForm = fieldForm;
        this.fieldRules = fieldRules;
      }
    },


    /**
     * 地址change
     */
    otherChange: function otherChange(data, field) {
      var _this4 = this;

      if (field.form_type === 'customer') {
        this.itemsForEach(this.fieldList, function (fieldItem) {
          if (fieldItem.form_type === 'contract') {
            // 如果是合同 改变合同样式和传入客户ID
            if (data.value.length > 0) {
              fieldItem.disabled = false;
              var customerItem = data.value[0];
              customerItem['moduleType'] = 'customer';
              customerItem['params'] = { check_status: 2 };
              fieldItem['relation'] = customerItem;
            } else {
              fieldItem.disabled = true;
              fieldItem['relation'] = {};
            }
            _this4.fieldForm[fieldItem.field] = [];
          } else if (fieldItem.form_type === 'receivables_plan') {
            fieldItem.disabled = true;
            fieldItem['relation'] = {};
            _this4.fieldForm[fieldItem.field] = '';
          }
        });
      } else if (field.form_type === 'contract') {
        var planItem = this.getItemWithFromType(this.fieldList, 'receivables_plan');
        if (planItem) {
          if (data.value.length > 0) {
            planItem.disabled = false;
            var contractItem = data.value[0];
            contractItem['moduleType'] = 'contract';
            planItem['relation'] = contractItem;
          } else {
            planItem.disabled = true;
            planItem['relation'] = {};
          }
          this.fieldForm[planItem.field] = '';
        }
      } else if (field.form_type === 'receivables_plan') {
        var dataValue = data.data || {};
        this.fieldForm.return_time = dataValue.return_date;
        this.fieldForm.money = dataValue.money;
        this.fieldForm.return_type = dataValue.return_type;
      }
      this.$set(this.fieldForm, field.field, data.value);
      this.$refs.crmForm.validateField(field.field);
    },


    /**
     * 审批信息值更新
     */
    examineValueChange: function examineValueChange(data) {
      this.examineInfo = data;
    },


    /**
     * 关闭
     */
    close: function close() {
      this.$emit('close');
    }
  }
};